import {render} from 'preact';
import {jsonAnswerMock1} from '../data/get-mock-data';
import WidgetComponent from '../components/widget/index.jsx';
import ShareComponent from '../components/share';
import WidgetModel from '../model/widget';
import ProgressModule from '../moduls/progress';

const OBJECT_FROM_WINDOW_NAME = `MKWidgetPolls`;
const DEFAULT_WIDGET_PLACE = `rosatom-game`;

export default class Loader {
  static start() {
    const responseData = Loader.loadData();
    const modelData = new WidgetModel(responseData[0]);
    const progress = new ProgressModule(modelData.start, responseData[0].steps);

    render(<ShareComponent />, document.querySelector('.header__share-wrapper'));
    const widgets = (OBJECT_FROM_WINDOW_NAME in window) ? window.MKWidgetPolls : [];

    for (let widget of widgets) {
      const selector = ('place' in widget) ? `#${widget.place}` : `#${DEFAULT_WIDGET_PLACE}`;

      render(<WidgetComponent data={modelData} progress={progress}/>, document.querySelector(selector));
    }
  }

  static loadData() {
    // позже будет реализовано взаимодействие с сервером
    return JSON.parse(jsonAnswerMock1);
  }
}



// WEBPACK FOOTER //
// ./moduls/loader.jsx